import { USER_LANG } from "@constants/global";
import setLanguage from "next-translate/setLanguage";
import useTranslation from "next-translate/useTranslation";
import { Button } from "components/ui/v2";

export enum EAvailableLanguages {
  es = "es",
  en = "en"
}

interface IToggleLangProps {
  className?: string;
  onToggle?: (newLang: EAvailableLanguages) => void;
  currentLang?: EAvailableLanguages;
}

const ToggleLang = (props: IToggleLangProps) => {
  const { onToggle, className, currentLang: propLang } = props;
  const { lang } = useTranslation("common");

  const currentLang = propLang || localStorage.getItem(USER_LANG) || lang;
  const selectedLang = propLang || lang;

  if (!propLang && currentLang !== lang) {
    localStorage.setItem(USER_LANG, lang);
  }

  const changeLanguage = () => {
    const newLang =
      selectedLang === "es" ? EAvailableLanguages.en : EAvailableLanguages.es;

    if (onToggle) {
      onToggle(newLang);
    } else {
      localStorage.setItem(USER_LANG, newLang);
      setLanguage(newLang, true); // Force page reload to update translations
    }
  };

  return (
    <Button
      variant="ghost"
      shape="pill"
      aria-label="Toggle language"
      className={`h-10 gap-2 rounded-full border border-slate-200/70 bg-white/70 px-4 text-slate-600 shadow-sm backdrop-blur-sm transition hover:bg-white hover:shadow dark:border-white/10 dark:bg-white/5 dark:text-zinc-300 dark:hover:bg-white/10 ${className || ""}`}
      onClick={changeLanguage}
      size="md"
    >
      <svg
        className="h-4 w-4 text-gray-700 dark:text-gray-200"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
        />
      </svg>
      <span className="text-sm font-medium text-gray-700 dark:text-gray-200">
        {selectedLang === "es" ? "ES" : "EN"}
      </span>
    </Button>
  );
};

export default ToggleLang;
